"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _superagent = _interopRequireDefault(require("superagent"));

var _AlertBar = _interopRequireDefault(require("@icare/components/lib/AlertBar/AlertBar"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GlobalAlertBar = /*#__PURE__*/function (_React$Component) {
  _inherits(GlobalAlertBar, _React$Component);

  var _super = _createSuper(GlobalAlertBar);

  function GlobalAlertBar(props) {
    var _this;

    _classCallCheck(this, GlobalAlertBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, siteApiUrl, siteAlertUrl, resp;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, siteApiUrl = _this$props.siteApiUrl, siteAlertUrl = _this$props.siteAlertUrl;
              _context.next = 3;
              return _superagent.default.get("".concat(siteApiUrl, "/").concat(siteAlertUrl));

            case 3:
              resp = _context.sent;

              if ((0, _utils.isResponseStructureValid)(resp)) {
                _this.setState({
                  showAlertMessage: true,
                  data: resp.body.data.attributes.alerts,
                  browserSpecification: resp.body.data.attributes.browserSpecification
                });
              } else {
                _this.setState({
                  showAlertMessage: false,
                  data: null
                });
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _this.state = {
      showAlertMessage: false,
      data: null,
      browserSpecification: {
        isIE: true,
        isOpera: true,
        isFirefox: true,
        isChrome: true,
        isSafari: true,
        isEdge: true
      }
    };
    return _this;
  }

  _createClass(GlobalAlertBar, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          showAlertMessage = _this$state.showAlertMessage,
          data = _this$state.data,
          browserSpecification = _this$state.browserSpecification;

      if (!showAlertMessage) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_AlertBar.default, {
        data: data,
        browserSpecification: browserSpecification,
        showAlertMessage: showAlertMessage
      });
    }
  }]);

  return GlobalAlertBar;
}(_react.default.Component);

exports.default = GlobalAlertBar;

_defineProperty(GlobalAlertBar, "propTypes", {
  siteApiUrl: _propTypes.default.string.isRequired,
  siteAlertUrl: _propTypes.default.string
});

_defineProperty(GlobalAlertBar, "defaultProps", {
  siteAlertUrl: 'api/sitealerts'
});
//# sourceMappingURL=GlobalAlertBar.js.map